import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    fetchSingleNotification(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/notifications/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addNotification(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/notifications', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
